import { render } from "./ProductFavourites.vue?vue&type=template&id=c0bd1c70&scoped=true"
import script from "./ProductFavourites.vue?vue&type=script&lang=js"
export * from "./ProductFavourites.vue?vue&type=script&lang=js"

import "./ProductFavourites.vue?vue&type=style&index=0&id=c0bd1c70&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0bd1c70"]])

export default __exports__